import {createElement, getParentElementByClassName} from "./Dom.ts";
import {generateModale, hideModal} from "./Modal.ts";
import {$post} from "./Ajax.ts";
import {refreshPage} from "./Utils.ts";

export function handleRemoveAccess(event: DOMEvent<HTMLElement>) {
    event.preventDefault()
    const target = getParentElementByClassName(event.target, "acces_from_organisation")
    const modalId = "modal-delete-access"

    const textarea = createElement('textarea', ['fr-input', 'fr-my-2w'])
    textarea.cols = 55
    textarea.rows = 6
    textarea.id = "motif_revocation_acces_lecture"

    const btn = createElement('button', ['fr-btn'])
    btn.id = "enregistrer_motif_revocation_acces_lecture"
    btn.innerText = "Enregistrer"
    generateModale(modalId, {
        title: "Veuillez en détailler la raison",
        content: textarea,
        actions: [btn]
    })

    btn.addEventListener('click', () => {
        // si le message n'est pas vide
        if (textarea.value.trim() != "") {
            const url = "/instructions/acces/" + target?.dataset.acces + "/remove/"
            $post(url, {
                'motif_revocation_acces_lecture': textarea.value
            }).then(() => {
                if (target?.dataset.removepostaction == "close") {
                    window.close()
                } else {
                    refreshPage()
                }
            }).finally(() => {
                // Si probleme dans le post
                hideModal(modalId)
            })
        } else {
            alert('Vous devez donner un motif pour pouvoir revoquer un accès en lecture. Ce dernier n\'a donc pas encore été révoqué, veuillez recommencer.')
        }
    })
}